export default __webpack_public_path__ + "maps-examples-custom-style-thumbnail-960-ad90d455c47ac0153064235e54ff3b2e.webp";